(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMarquee(section) {
    var viewport = section.querySelector('.marquee-strip-viewport');
    var track = section.querySelector('.marquee-strip-track');
    var originalGroup = section.querySelector('.marquee-strip-group');

    if (!viewport || !track || !originalGroup) return;

    var direction = section.dataset.direction === 'right' ? 1 : -1;
    var duration = parseFloat(section.dataset.speed) || 20;

    var groupWidth = 0;
    var speedPxPerSec = 0;
    var pos = 0;
    var lastTime = null;
    var rafId = null;

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fillTrack() {
      // remove all clones, keep only the first (original) group
      while (track.children.length > 1) {
        track.removeChild(track.lastChild);
      }

      groupWidth = originalGroup.getBoundingClientRect().width;
      if (groupWidth <= 0) return;

      var viewportWidth = viewport.getBoundingClientRect().width;
      var totalWidth = groupWidth;

      while (totalWidth < viewportWidth * 2 || track.children.length < 2) {
        var clone = originalGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        totalWidth += groupWidth;
      }

      speedPxPerSec = groupWidth / duration;
      pos = 0;
      lastTime = null;
    }

    function frame(time) {
      if (lastTime === null) lastTime = time;
      var delta = (time - lastTime) / 1000;
      lastTime = time;

      pos += speedPxPerSec * delta;
      if (pos >= groupWidth) pos -= groupWidth;

      var translate = direction < 0 ? -pos : pos - groupWidth;
      track.style.transform = 'translateX(' + translate + 'px)';

      rafId = requestAnimationFrame(frame);
    }

    fillTrack();

    if (!prefersReducedMotion && groupWidth > 0) {
      rafId = requestAnimationFrame(frame);
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        if (rafId) cancelAnimationFrame(rafId);
        fillTrack();
        if (!prefersReducedMotion && groupWidth > 0) {
          rafId = requestAnimationFrame(frame);
        }
      }, 200);
    });
  }

  document.querySelectorAll('.marquee-strip-section').forEach(initMarquee);
})();

  } catch(e) { console.error(e); }
})();
})();
